import { render, staticRenderFns } from "./jianyi.vue?vue&type=template&id=673735a4&scoped=true&"
import script from "./jianyi.vue?vue&type=script&lang=ts&"
export * from "./jianyi.vue?vue&type=script&lang=ts&"
import style0 from "./jianyi.vue?vue&type=style&index=0&id=673735a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673735a4",
  null
  
)

export default component.exports